import { jsxs, jsx } from "react/jsx-runtime";
import Statistic from "antd/es/statistic";
import classnames from "../../utils/classnames.js";
import Typography from "../Typography/Typography.js";
import './Price.css';/* empty css           */
const Price = ({
  title,
  value,
  oldValue,
  className,
  extra,
  titleColor = "dark-light",
  valueColor = "darkest",
  oldValueColor = "dark-light",
  oldValuePosition = "bottom",
  ...props
}) => {
  return /* @__PURE__ */ jsxs("div", { className: classnames(["perxis-auto-price", `perxis-auto-price--old-value-${oldValuePosition}`], className), children: [
    !!title && /* @__PURE__ */ jsx(Typography.Text, { level: "main", color: titleColor, className: classnames("perxis-auto-price__title"), children: title }),
    /* @__PURE__ */ jsxs("div", { className: classnames("perxis-auto-price__content"), children: [
      /* @__PURE__ */ jsx(
        Statistic,
        {
          value,
          valueRender: (node) => /* @__PURE__ */ jsx(Typography.Text, { level: "main", color: valueColor, className: classnames("perxis-auto-price__current-value"), children: node }),
          className: classnames("perxis-auto-price__current"),
          ...props
        }
      ),
      !!extra && /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-price__extra"), children: extra }),
      !!oldValue && /* @__PURE__ */ jsx(
        Statistic,
        {
          value: oldValue,
          valueRender: (node) => /* @__PURE__ */ jsx(Typography.Text, { level: "super-small", color: oldValueColor, className: classnames("perxis-auto-price__old-value"), children: node }),
          className: classnames("perxis-auto-price__old"),
          ...props
        }
      )
    ] })
  ] });
};
export {
  Price as default
};
//# sourceMappingURL=Price.js.map
